import { StaticCanvas } from 'components/canvas';
import IdenticonGenerator from 'post-components/identicon-generator';
import * as React from 'react';
export default {
  StaticCanvas,
  IdenticonGenerator,
  React
};